import type { RouteLocationNormalized } from 'vue-router'
import { headTags, legalMeta, notFoundTitle, pageMeta, SITE, splitLocale, type PageMeta } from './seo'

// Head tags we own are marked data-mk so each navigation replaces them cleanly
// (the prerendered HTML carries the same marker).
const MARK = 'data-mk'

function add(tag: 'meta' | 'link' | 'script', attrs: Record<string, string>, text?: string) {
  const el = document.createElement(tag)
  for (const [k, v] of Object.entries(attrs)) el.setAttribute(k, v)
  el.setAttribute(MARK, '')
  if (text) el.textContent = text
  document.head.appendChild(el)
}

// data-cms: CMS overrides from the previous page (cms/head.ts).
const clear = () => document.head.querySelectorAll(`[${MARK}], [data-cms]`).forEach((el) => el.remove())

/** Replace the page head (title, meta, links, JSON-LD) with m. */
export function applyMeta(m: PageMeta): void {
  clear()
  document.title = m.title
  document.documentElement.lang = m.locale
  for (const [tag, attrs, text] of headTags(m)) add(tag, attrs, text)
}

/** Sync <head> with the route. Registered once via router.afterEach. */
export function applySeo(to: RouteLocationNormalized): void {
  clear()
  const page = to.meta.mkPage
  const locale = to.meta.locale ?? 'en'
  const slug = typeof to.params.slug === 'string' ? to.params.slug : undefined
  const name = String(to.name)
  const m = page ? pageMeta(page, locale, slug) : to.meta.legal ? legalMeta(to.meta.legal, locale) : null

  if (!m) {
    document.title = name === 'not-found' ? notFoundTitle(splitLocale(to.path).locale)
      : name === 'verify' || name === 'verify-code' ? `Verify a document - ${SITE.name}`
      : SITE.name
    add('meta', { name: 'robots', content: 'noindex' })
    return
  }

  document.title = m.title
  document.documentElement.lang = m.locale
  for (const [tag, attrs, text] of headTags(m)) add(tag, attrs, text)
}
